export default "__VITE_ASSET__CKFf4j7e__"